import { render, staticRenderFns } from "./supplierContractRenew.vue?vue&type=template&id=9595fde0"
import script from "./supplierContractRenew.vue?vue&type=script&lang=js"
export * from "./supplierContractRenew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports